import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Input,
  OnDestroy,
  Renderer2,
  Output,
  EventEmitter,
} from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { CdkPortal } from '@angular/cdk/portal';
import { OverlayServiceService } from '../../services/overlay.service';

@Component({
  selector: 'app-custom-overlay',
  templateUrl: './custom-overlay.component.html',
  styleUrls: ['./custom-overlay.component.sass'],
})
export class CustomOverlayComponent implements OnInit, OnDestroy {
  @Input() connectedTo: any;
  @Input() text: string;
  @Input() get id(): number {
    return this._id;
  }
  set id(id: number) {
    if (typeof id === 'string') {
      this._id = parseInt(id, 10);
    } else {
      this._id = id;
    }
  }
  private _id: number;
  @Output() closed = new EventEmitter<any>();
  @ViewChild(CdkPortal) portal: ElementRef;
  overlayRef: OverlayRef;
  private nativeElement;

  constructor(
    private overlay: Overlay,
    private renderer: Renderer2,
    private overlayService: OverlayServiceService
  ) {}

  ngOnInit() {
    this.overlayService.registerOverlay(this);
    console.log(this.connectedTo);
    if (this.connectedTo.getBoundingClientRect) {
      this.nativeElement = this.connectedTo;
    } else {
      this.nativeElement = this.connectedTo._elementRef.nativeElement;
    }
  }

  public showOverlay() {
    const positionStrategy = this.overlay
      .position()
      .flexibleConnectedTo(this.nativeElement)
      .withPositions([
        {
          originX: 'start',
          originY: 'bottom',
          overlayX: 'end',
          overlayY: 'top',
          offsetX: -10,
          offsetY: -50,
        },
      ])
      .withGrowAfterOpen(true);
    const scrollStrategy = this.overlay.scrollStrategies.reposition();
    const overlayRef = this.overlay.create({
      positionStrategy,
      scrollStrategy,
      hasBackdrop: true,
      backdropClass: 'my-backdrop',
    });
    this.overlayRef = overlayRef;
    overlayRef.detachments().subscribe(() => {
      this.renderer.removeClass(this.nativeElement, 'elevate');
      this.renderer.removeAttribute(this.nativeElement, 'id');
    });
    overlayRef.attach(this.portal);
    this.renderer.addClass(this.nativeElement, 'elevate');
    this.renderer.setAttribute(this.nativeElement, 'id', 'onboarding-active');
    overlayRef.backdropClick().subscribe(() => this.hideOverlay());
  }

  public hideOverlay() {
    if (this.overlayRef && this.overlayRef.hasAttached) {
      this.overlayService.wasClosed(this._id);
      this.overlayRef.dispose();
      this.closed.emit();
    }
  }

  ngOnDestroy() {
    //this.hideOverlay();
    //this.overlayService.destroyOverlay(this);
  }
}
